export default "__VITE_ASSET__BB0XDDC0__"